import { consumeVoucherToParticipant, getParticipantsAdmitted, getScannedCount, getScannerTicket,scanIn, scanOut } from "~/api/provider";
import { addingParticipant, consumeVoucher, incrementScannedToday, scanningVoucher, setLoadedParticipant, setMessageError, setNewParticipant, setParticipants, setScannedToday, startGettingParticipants } from "./participantSlice";

export const startLoadingParticipants = ( currentDate ) => {
	return async( dispatch, getState ) => {
		const { id: eventId } = getState().event;

		if (!eventId) throw new Error('Event not found');

		dispatch( startGettingParticipants() );

		const resp = await getParticipantsAdmitted( eventId, currentDate );

		if (resp.ok && !resp.participants?.message) {
			return dispatch( setParticipants( resp.participants ) );
		}

		const errorMessage = resp.errorMessage ?? resp.participants?.message ?? 'There is an error. Try again';

		dispatch( setMessageError( errorMessage ) );
	}
} 

export const startLoadingScannedCount = () => {
	return async( dispatch, getState ) => {
		const { accessCode } = getState().event;

		if (!accessCode) return;

		// No date is sent: the server resolves "today" from the event's own timezone,
		// so the count rolls over at the venue's midnight rather than the device's.
		const resp = await getScannedCount( accessCode );

		// Informational only. On failure the count stays null and simply is not
		// rendered, so a count outage can never block or interrupt a scan.
		if (resp.ok) {
			dispatch( setScannedToday( resp.scannedCount ) );
		}
	}
}

export const startAddingParticipant = (ticketId, currentDate) => {
    return async (dispatch, getState) => {
        dispatch(addingParticipant);

        const { accessCode, id: eventId, isMultipleScannedInEnabled, isScanOutEnabled } = getState().event;
        const { participants } = getState().participant;

        if (!isScanOutEnabled) {
            if (participants?.find(p => p.id === ticketId)) {
                const part = participants.find(p => p.id === ticketId);
                dispatch(setLoadedParticipant({
                    ...part, eventId, registrationId: ticketId, status: 'duplicate'
                }));
                return dispatch(setMessageError('duplicate'));
            }

            const resp = await getScannerTicket(
                ticketId, accessCode, currentDate, isMultipleScannedInEnabled);

            if (resp.ok) {
                let participant = { ...resp.participant, eventId, registrationId: ticketId };
                dispatch(setLoadedParticipant(participant));

                if (resp.status === 'admitted') {
                    participant = {
                        ...participant,
                        admittedOn: [...participant.admittedOn, currentDate]
                    };
                    dispatch(setNewParticipant(participant));
                    dispatch(incrementScannedToday());
                    return;
                }
            }

            return dispatch(setMessageError(resp.errorMessage ?? resp.status));
        }

        const resp = await scanIn(ticketId, accessCode);

        if (resp.ok) {
            dispatch(setLoadedParticipant({
                ...resp.data,
                eventId,
                registrationId: ticketId,
                status: 'admitted',
            }));
            dispatch(setNewParticipant(resp.data));
            return;
        }

        dispatch(setMessageError(resp.errorMessage));
    };
};
export const startScanningOut = (ticketId) => {
    return async (dispatch, getState) => {
        dispatch(addingParticipant);

        const { accessCode, id: eventId } = getState().event;

        const resp = await scanOut(ticketId, accessCode);

        if (!resp.ok)
            return dispatch(setMessageError(resp.errorMessage));

        dispatch(setLoadedParticipant({
            ...resp.data,
            eventId,
            registrationId: ticketId,
            status: 'scanned-out',
        }));

        dispatch(setNewParticipant({
            ...resp.data,
            eventId,
            registrationId: ticketId,
            status: 'scanned-out',
            messageSaved: 'Participant scanned out successfully',
        }));
    };
};

export const startScanningVoucher = ( participantId ) => {
	return async( dispatch, getState ) => {

		dispatch( scanningVoucher() );

		const { accessCode, id: eventId } = getState().event;
		const { participants } = getState().participant;

		dispatch( setLoadedParticipant( participants.find(p => p.id === participantId ) ) );

		const resp = await consumeVoucherToParticipant( accessCode, eventId, participantId );

		if (!resp.ok) { return dispatch( setMessageError( resp.errorMessage ) )}

		dispatch( consumeVoucher( resp.data ) );
	}
}
